import { BaseHttpResource } from "src/app/infrastructure/BaseHttpResource";
import httpClient from "./httpClient";

// const BASE_URL = 'https://api.llama.im/api';
const BASE_URL = process.env.API_URI;
const defaultOptions = {
  timeOffset: true,
  responseType: 'json',
  accessType: 'json',
  contentType: 'json'
};

const httpResource = new BaseHttpResource(BASE_URL, httpClient, defaultOptions);

export default httpResource;


// WEBPACK FOOTER //
// ./src/app/modules/core/infrastructure/httpResource.ts